import classNames from "classnames";
import { ComponentProps, forwardRef } from "react";
import { MaterialSymbolType } from "./IconConstant";

export interface IconProps extends ComponentProps<"span"> {
  icon: MaterialSymbolType;
  size?: number;
  filled?: boolean;
  weight?: number;
  className?: string;
}

const Icon = forwardRef<HTMLSpanElement, IconProps>(
  (
    { icon, filled, size = 20, color, className, weight = 300, ...props },
    ref
  ) => {
    return (
      <span
        {...props}
        className={classNames("material-symbols-outlined", className, {
          filled: filled,
        })}
        ref={ref}
        style={{
          display: "flex",
          cursor: props.onClick ? "pointer" : undefined,
          width: `${size}px`,
          height: `${size}px`,
          fontSize: `${size}px`,
          color: color,
          userSelect: "none",
          fontVariationSettings: `'FILL' ${filled ? 1 : 0}, 'wght' ${weight}, 'GRAD' 0, 'opsz' 22`,
          ...props.style,
        }}
      >
        {icon}
      </span>
    );
  }
);

Icon.displayName = "Icon";

export default Icon;
